module.exports = __webpack_public_path__ + "static/Bar-Rustic-Bar-Design-feature-7e9ce0d2934bec56f9f922cb0c193cdd.jpg";